import React from 'react'
import { FormattedMessage } from 'react-intl'

export const SORTIE_TOOLTIP_TITLE = (level) => {
    return (
        <FormattedMessage
            id='sortie_tooltip.title'
            defaultMessage='Вылазка в {level} дивизионе'
            values={{
                level,
            }}
        />
    )
}

export const SORTIE_TOOLTIP_SELECTED = (
    <FormattedMessage
        id='sortie_tooltip.selected'
        defaultMessage='Текущий дивизион'
    />
)



// WEBPACK FOOTER //
// ./components/BattleWizard/components/SortieTooltip/constants.jsx